import { memo } from "react";
import React from "react";
import Header from "../../header/Header";
import Footer from "../Footer";
import { useEffect } from "react";
import "./accesibilidad.scss";


const Accesibilidad = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Desplazar a la parte superior de la página
    }, []);

    return (<>
        <Header />

        <div className="contenido" style={{ marginTop: "0px" }} role="main" data-landmark-index="4">
            <div>
                <h2 >DECLARACIÓN DE ACCESIBILIDAD</h2>
                <p>&nbsp;</p>
                <p>La Junta de Extremadura se ha comprometido a hacer accesible su sitio web de conformidad con el&nbsp;<a class="enlace" target="_blank" rel="noopener noreferrer" href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2018-12699">Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web y aplicaciones para dispositivos móviles del sector público.</a> Este sitio web, ha sido diseñado y programado siguiendo las directrices de la iniciativa WAI (Web Accessibility Initiative, <a
                    className="enlace"
                    href="https://www.w3.org/WAI"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.w3.org/WAI
                </a>), que marca unos estándares internacionales en la creación de contenidos webs accesibles a todo el mundo. </p>
                <p>La presente declaración de accesibilidad se aplica al sitio web&nbsp; <a class="enlace" href="https://areadepersonal.juntaex.es/" target="">https://areadepersonal.juntaex.es/</a></p>
                <span>&nbsp;</span>
            </div>
            <div>
                <h2>Pautas de accesibilidad</h2>
                <p>Se han tomado diversas medidas para hacer el sitio web más accesible, entre ellas:</p>
                <span>&nbsp;</span>
                <ul>
                    <li class="lista">
                        <p>Orden lógico de presentación de los elementos en pantalla.</p>
                    </li>
                    <li class="lista">
                        <p>Texto descriptivo de las imágenes.</p>
                    </li>
                    <li class="lista">
                        <p>Tamaño adecuado a la resolución de pantalla.</p>
                    </li>
                    <li class="lista">
                        <p>Acceso directo a la información más relevante del portal.</p>
                    </li>
                </ul>
                <span>&nbsp;</span>
            </div>
            <div>
                <h2>Situación de cumplimiento</h2>
                <p>Este sitio web es <strong>parcialmente conforme</strong> con el RD 1112/2018. Nivel de conformidad (AA).</p>
                <span>&nbsp;</span>
            </div>
            <div>
                <h2>Contenido no accesible</h2>
            </div>
            <div>
                <p>a) Falta de conformidad con el <strong>RD 1112/2018</strong> en los siguientes puntos:</p>
                <ul>
                    <li class="lista">
                        <p>En algunas páginas puede haber controles en formulario sin etiquetar, o imágenes y texto con enlace al mismo recurso. Algunos enlaces sin texto descriptivos.</p>
                    </li>
                    <li class="lista">
                        <p>Algunos vídeos carecen de subtitulado o audiodescripción.</p>
                    </li>
                    <li class="lista">
                        <p>La información, estructura y relaciones comunicadas a través de la presentación en algún caso no pueden ser determinadas por software</p>
                    </li>
                </ul>
                <span>&nbsp;</span>
            </div>
            <div>
                <p>b) <strong>Carga desproporcionada</strong>: Los archivos PDF o documentos ofimáticos publicados antes del 20 de septiembre de 2018 no se revisarán, ya que su adaptación supondría una carga desproporcionada.</p>
                <span>&nbsp;</span>
            </div>
            <div>
                <p>c) El contenido <strong>no entra dentro del ámbito de la legislación</strong> aplicable: Podrían existir archivos ofimáticos en PDF u otros formatos publicados antes del 20 de septiembre de 2018 que no cumplan en su totalidad todos los requisitos de accesibilidad.</p>
                <span>&nbsp;</span>
            </div>
            <div>
                <p>Puede haber contenidos de terceros que no estén desarrollados en esta Unidad, ni bajo su control, como archivos ofimáticos correspondientes a convocatorias de empleo público de diferentes organismos públicos que deban publicarse en este sitio.</p>
                <span>&nbsp;</span>
            </div>
            <div>
                <h2>Preparación de la presente Declaración de Accesibilidad</h2>
                <p>La presente declaración fue preparada el 31 de octubre de 2025.</p>
                <p>El método empleado para preparar la declaración ha sido una <strong>evaluación externa</strong> de la Empresa AYESA, analizando el nivel de conformidad UNE-EN 301 549:2022.</p>
                <span>&nbsp;</span>
            </div>
            <div>
                <h2>Observaciones y datos de contacto</h2>
                <p>Puede realizar comunicaciones sobre requisitos de accesibilidad (artículo 10.2.a) del RD 1112/2018) como, por ejemplo:</p>
                <ul>
                    <li class="lista">
                        <p>Informar sobre cualquier posible <strong>incumplimiento </strong>por parte de este sitio web.</p>
                    </li>
                    <li class="lista">
                        <p>Transmitir otras <strong>dificultades </strong>de acceso al contenido.</p>
                    </li>
                    <li class="lista">
                        <p>Formular cualquier otra <strong>consulta o sugerencia</strong> de mejora relativa a la accesibilidad del sitio web.</p>
                    </li>
                </ul>

                <p>A través del siguiente mail: <a className="enlace" href="https://outlook.office.com/mail/deeplink/compose?to=dgfp.hap@juntaex.es&subject=Consulta&body=Hola,%20tengo%20una%20pregunta.">dgfp.hap@juntaex.es</a> , así como del resto de opciones recogidas en la Ley 39/ 2015, de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas.</p>
                <p>Las comunicaciones serán recibidas y tratadas por la Dirección General de Función Pública de la Junta de Extremadura.</p>
                <p>Asimismo, puede presentar:</p>

                <ul>
                    <li class="lista">
                        <p>una&nbsp;<strong>Queja&nbsp;</strong>relativa al cumplimiento de los requisitos del RD 1112/2018 o</p>
                    </li>
                    <li class="lista">
                        <p>una&nbsp;<strong>Solicitud de Información Accesible</strong>&nbsp;relativa a:</p>

                        <ul>
                            <li class="lista">
                                <p>contenidos que están excluidos del ámbito de aplicación del RD 1112/2018 según lo establecido por el artículo 3, apartado 4.</p>
                            </li>
                            <li class="lista">
                                <p>contenidos que están exentos del cumplimiento de los requisitos de accesibilidad por imponer una carga desproporcionada.</p>
                            </li>
                        </ul>
                    </li>
                </ul>

                <p>En la Solicitud de información accesible, se debe concretar, con toda claridad, los hechos, razones y petición que permitan constatar que se trata de una solicitud razonable y legítima.</p>

                <p>Las&nbsp;<strong>Solicitudes de información accesible</strong> y <strong>quejas&nbsp;</strong>serán presentadas y registradas según el procedimiento de Quejas y Sugerencias de la sede electrónica de la Junta de Extremadura.</p>

                <p>Las comunicaciones, quejas y solicitudes de información accesible serán recibidas y tratadas por el Servicio de Gestión y Provisión de Personal de la Dirección General de Función Pública de la Consejería de Hacienda y Administración Pública de la Junta de Extremadura.</p>
                <span>&nbsp;</span>
            </div>

            <div>
                <h2 class="class-H2-tts-10 i4t-reference-include" id="i4t-id-37">Procedimiento de aplicación</h2>
                <p>El procedimiento de reclamación recogido en el artículo 13 del RD 1112/2018 entró en vigor el 20 de septiembre de 2020.</p>
                <p>Si una vez realizada una <strong>solicitud de información accesible o queja</strong>, ésta hubiera sido <strong>desestimada</strong>, o <strong>no se estuviera de acuerdo con la decisión adoptada</strong>, o <strong>la respuesta no cumpliera los requisitos</strong> contemplados en el artículo 12.5, la persona interesada podrá iniciar una <strong>reclamación</strong>.</p>
                <p>La reclamación puede ser presentada través del <strong>Registro Electrónico General de la Sede Electrónica de la Junta de Extremadura</strong>, así como en el resto de opciones recogidas en la Ley 39/2015, de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas</p>
                <p>Las reclamaciones serán recibidas y tratadas por la Secretaría General de Administración Digital de la Consejería de Hacienda y Administración Pública de la Junta de Extremadura.</p>
                <p>&nbsp;</p>
            </div>
            <div>
                <h2 class="class-H2-tts-10 i4t-reference-include" id="i4t-id-37">Contenido opcional</h2>
                <p>Este sitio web aplica los requisitos de la Norma <a className="enlace" href="https://administracionelectronica.gob.es/PAe/accesibilidad/une-en-301549-2020.pdf">UNE-EN 301549:2020 </a>considerando las excepciones del RD 1112/2018.</p>
                <p>La última revisión de la accesibilidad se ha realizado el 31 de octubre de 2025.</p>
                <p>El sitio web está optimizado para los navegadores Microsoft Internet Explorer 8.0 o versiones superiores y las últimas versiones vigentes de FireFox, Safari, Opera y Google Chrome.</p>
                <p>El sitio web está diseñado para su visualización Responsive, con lo que se visualiza de forma óptima en los dispositivos tablet y móviles. </p>
                <p>&nbsp;</p>
            </div>
        </div>
        <Footer></Footer>

    </>
    );
};

export default memo(Accesibilidad);
